import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const MentionIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue0e6'}</MuiIcon>
    );
}